import { DataModel } from "common/models/utility-models/base-model";



export class stateListModel extends DataModel {
  stateID: '';
  stateName: '';
  region: '';
  countryID: '';
}

